import { useState } from "react";
import clsx from "clsx";
import styles from "./index.module.scss";

export default function Share({ productName, productUrl, photo }) {
  const Share = {
    vkontakte() {
      let url = "http://vkontakte.ru/share.php?";
      url += `url=${encodeURIComponent(productUrl)}`;
      url += `&title=${encodeURIComponent(productName)}`;
      url += `&description=${encodeURIComponent(productName)}`;
      url += `&image=${encodeURIComponent(photo)}`;
      url += "&noparse=true";
      Share.popup(url);
    },
    odnoklassniki() {
      let url = "http://www.odnoklassniki.ru/dk?st.cmd=addShare&st.s=1";
      url += `&st.comments=${encodeURIComponent(productName)}`;
      url += `&st._surl=${encodeURIComponent(productUrl)}`;
      Share.popup(url);
    },
    twitter() {
      let url = "http://twitter.com/share?";
      url += `text=${encodeURIComponent(productName)}`;
      url += `&url=${encodeURIComponent(productUrl)}`;
      url += `&counturl=${encodeURIComponent(productUrl)}`;
      Share.popup(url);
    },
    mailru() {
      let url = "http://connect.mail.ru/share?";
      url += `url=${encodeURIComponent(productUrl)}`;
      url += `&title=${encodeURIComponent(productName)}`;
      url += `&description=${encodeURIComponent(productName)}`;
      url += `&imageurl=${encodeURIComponent(photo)}`;
      Share.popup(url);
    },
    telegram() {
      let url = "https://t.me/share/url?";
      url += `url=${window.location.href}`;
      url += `&text=${productName}`;
      url += "&utm_source=share2";

      Share.popup(url);
    },
    popup(url) {
      window.open(url, "", "toolbar=0,status=0,width=626,height=436");
    },
  };

  const [isShowMobile, setIsShowMobile] = useState(false);

  return (
    <div className={clsx(isShowMobile && styles.ShareShowMobile, styles.Share)}>
      <div
        className={styles.ShareMobile}
        onClick={() => {
          setIsShowMobile(!isShowMobile);
        }}
      >
        {isShowMobile && (
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 1L1 13M1 1L13 13"
              stroke="#384250"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
        {!isShowMobile && (
          <svg
            width="20"
            height="22"
            viewBox="0 0 20 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.59 12.51L13.42 16.49M13.41 5.51L6.59 9.49M19 4C19 5.65685 17.6569 7 16 7C14.3431 7 13 5.65685 13 4C13 2.34315 14.3431 1 16 1C17.6569 1 19 2.34315 19 4ZM7 11C7 12.6569 5.65685 14 4 14C2.34315 14 1 12.6569 1 11C1 9.34315 2.34315 8 4 8C5.65685 8 7 9.34315 7 11ZM19 18C19 19.6569 17.6569 21 16 21C14.3431 21 13 19.6569 13 18C13 16.3431 14.3431 15 16 15C17.6569 15 19 16.3431 19 18Z"
              stroke="#6C737F"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </div>

      <div className={styles.ShareBlock}>
        <span>Поделиться:</span>
        <div>
          <a onClick={Share.vkontakte} aria-label="Поделиться во ВКонтакте">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.9669 19C5.4704 19 1.13755 13.75 1 5H4.78265C4.9202 11.44 7.67122 14.1 9.87203 14.66V5H13.4484V10.53C15.6492 10.32 17.9188 7.8 18.6753 5H22.2516C21.6326 8.43 19.1567 10.95 17.4373 12C19.2255 12.84 22.0453 15.01 23.0769 19H19.1567C18.3314 16.34 16.1994 14.31 13.4484 14.03V19H12.9669Z"
                fill="#9294A9"
              />
            </svg>
          </a>
          <a onClick={Share.telegram} aria-label="Поделиться в Telegram">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.8105 4.08692C18.5394 4.5573 2.873 10.6115 2.64225 10.7216C1.8755 11.0871 1.78586 11.57 2.42417 11.8966C2.48579 11.9281 3.5462 12.2692 4.78061 12.6546L7.02504 13.3553L12.1214 10.1484C14.9244 8.38456 17.2743 6.92163 17.3432 6.89747C17.5163 6.83676 17.6653 6.84243 17.7348 6.91239C17.7835 6.96134 17.7855 6.98591 17.7468 7.05786C17.7212 7.10546 15.8599 8.80584 13.6105 10.8365C11.3611 12.8671 9.5146 14.5444 9.5072 14.5639C9.4998 14.5833 9.4237 15.5971 9.3381 16.8168L9.1825 19.0343L9.3516 19.0114C9.4446 18.9988 9.5918 18.9505 9.6788 18.9041C9.7658 18.8577 10.3515 18.3241 10.9802 17.7183C11.609 17.1125 12.1452 16.6084 12.1719 16.5981C12.1984 16.5879 13.1998 17.3013 14.397 18.1836C15.5942 19.0659 16.6675 19.8314 16.7821 19.8847C17.0829 20.0245 17.4217 20.0383 17.6417 19.9199C17.8382 19.8141 18.0303 19.5513 18.1111 19.2777C18.1424 19.1718 18.8268 15.9907 19.6321 12.2085C20.9729 5.91143 21.0963 5.30177 21.0968 4.97494C21.0972 4.66614 21.0844 4.59269 21.0022 4.43016C20.9442 4.31557 20.8453 4.19858 20.7486 4.1302C20.5276 3.97383 20.1617 3.95696 19.8105 4.08692Z"
                fill="#9294A9"
              />
            </svg>
          </a>
        </div>
      </div>
    </div>
  );
}
